import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.mjs.js';
import React, { useMemo, useCallback } from 'react';
import { Flex, Box, Button } from '@chakra-ui/react';
import Typography from './Typography.js';
import { PageType } from './QuickSlotSetupModal.js';
import { ImageOfTypCs1, ImageOfOspCs1, ImageOfCheckoutCs1, ImageOfCartCs1, ImageOfProductCs1, ImageOfCartDrawer, ImageOfCartBanner, ImageOfCartRecommendation, ImageOfCartBundle, ImageOfCartUpsell, ImageOfProductBanner, ImageOfProductRecommendation, ImageOfProductBundle, ImageOfProductUpsell, ImageOfCheckoutBanner, ImageOfCheckoutRecommendation, ImageOfCheckoutBundle, ImageOfCheckoutUpsell, ImageOfPostPurchase, ImageOfTypAnnouncement, ImageOfTypBanner, ImageOfTypRecommendation, ImageOfTypBundle, ImageOfTypUpsell, ImageOfOspAnnouncement, ImageOfOspBanner, ImageOfOspRecommendation, ImageOfOspBundle, ImageOfOspUpsell, ImageOfCartCs6, ImageOfCartCs5, ImageOfCartCs4, ImageOfCartCs3, ImageOfCartCs2, ImageOfProductCs6, ImageOfProductCs5, ImageOfProductCs4, ImageOfProductCs3, ImageOfProductCs2, ImageOfCheckoutCs6, ImageOfCheckoutCs5, ImageOfCheckoutCs4, ImageOfCheckoutCs3, ImageOfCheckoutCs2, ImageOfTypCs6, ImageOfTypCs5, ImageOfTypCs4, ImageOfTypCs3, ImageOfTypCs2, ImageOfOspCs6, ImageOfOspCs5, ImageOfOspCs4, ImageOfOspCs3, ImageOfOspCs2 } from './images/ImageComponents.js';
import { t } from '../utils/i18n.js';
import { getEditorRedirectionUrl } from '../utils/editorRedirectionurl.js';
import InfoFilled from '../icons/InfoFilled.js';
import ExternalLink from '../icons/ExternalLink.js';
import CheckCircle from '../icons/CheckCircle.js';
import CheckedIconWithBorder from '../icons/CheckedIconWithBorder.js';

var PreMadeTemplateType;
(function (PreMadeTemplateType) {
    PreMadeTemplateType["CUSTOM_SLOT"] = "CUSTOM_SLOT";
    PreMadeTemplateType["DUPLICATE_SLOT"] = "DUPLICATE_SLOT";
    PreMadeTemplateType["PRODUCT_UPSELL"] = "PRODUCT_UPSELL";
    PreMadeTemplateType["PRODUCT_RECOMMENDATION"] = "PRODUCT_RECOMMENDATION";
    PreMadeTemplateType["BUNDLE"] = "BUNDLE";
    PreMadeTemplateType["BANNER"] = "BANNER";
    PreMadeTemplateType["ANNOUNCEMENT_BAR"] = "ANNOUNCEMENT_BAR";
})(PreMadeTemplateType || (PreMadeTemplateType = {}));
// Helper function to get custom slot image based on page type and slot number
var getCustomSlotImage = function (pageType, slotNumber) {
    // Cart custom slots
    if (pageType === PageType.PRE_PURCHASE_CART_PAGE) {
        switch (slotNumber) {
            case 1:
                return React.createElement(ImageOfCartCs1, { alt: "Cart Custom Slot 1" });
            case 2:
                return React.createElement(ImageOfCartCs2, { alt: "Cart Custom Slot 2" });
            case 3:
                return React.createElement(ImageOfCartCs3, { alt: "Cart Custom Slot 3" });
            case 4:
                return React.createElement(ImageOfCartCs4, { alt: "Cart Custom Slot 4" });
            case 5:
                return React.createElement(ImageOfCartCs5, { alt: "Cart Custom Slot 5" });
            case 6:
                return React.createElement(ImageOfCartCs6, { alt: "Cart Custom Slot 6" });
            default:
                return React.createElement(ImageOfCartCs1, { alt: "Cart Custom" });
        }
    }
    // Product custom slots
    if (pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE) {
        switch (slotNumber) {
            case 1:
                return React.createElement(ImageOfProductCs1, { alt: "Product Custom Slot 1" });
            case 2:
                return React.createElement(ImageOfProductCs2, { alt: "Product Custom Slot 2" });
            case 3:
                return React.createElement(ImageOfProductCs3, { alt: "Product Custom Slot 3" });
            case 4:
                return React.createElement(ImageOfProductCs4, { alt: "Product Custom Slot 4" });
            case 5:
                return React.createElement(ImageOfProductCs5, { alt: "Product Custom Slot 5" });
            case 6:
                return React.createElement(ImageOfProductCs6, { alt: "Product Custom Slot 6" });
            default:
                return React.createElement(ImageOfProductCs1, { alt: "Product Custom" });
        }
    }
    // Checkout custom slots
    if (pageType === PageType.CHECKOUT) {
        switch (slotNumber) {
            case 1:
                return React.createElement(ImageOfCheckoutCs1, { alt: "Checkout Custom Slot 1" });
            case 2:
                return React.createElement(ImageOfCheckoutCs2, { alt: "Checkout Custom Slot 2" });
            case 3:
                return React.createElement(ImageOfCheckoutCs3, { alt: "Checkout Custom Slot 3" });
            case 4:
                return React.createElement(ImageOfCheckoutCs4, { alt: "Checkout Custom Slot 4" });
            case 5:
                return React.createElement(ImageOfCheckoutCs5, { alt: "Checkout Custom Slot 5" });
            case 6:
                return React.createElement(ImageOfCheckoutCs6, { alt: "Checkout Custom Slot 6" });
            default:
                return React.createElement(ImageOfCheckoutCs1, { alt: "Checkout Custom" });
        }
    }
    // Thank You Page custom slots
    if (pageType === PageType.THANK_YOU_PAGE) {
        switch (slotNumber) {
            case 1:
                return React.createElement(ImageOfTypCs1, { alt: "Thank You Page Custom Slot 1" });
            case 2:
                return React.createElement(ImageOfTypCs2, { alt: "Thank You Page Custom Slot 2" });
            case 3:
                return React.createElement(ImageOfTypCs3, { alt: "Thank You Page Custom Slot 3" });
            case 4:
                return React.createElement(ImageOfTypCs4, { alt: "Thank You Page Custom Slot 4" });
            case 5:
                return React.createElement(ImageOfTypCs5, { alt: "Thank You Page Custom Slot 5" });
            case 6:
                return React.createElement(ImageOfTypCs6, { alt: "Thank You Page Custom Slot 6" });
            default:
                return React.createElement(ImageOfTypCs1, { alt: "Thank You Page Custom" });
        }
    }
    // Order Status Page custom slots
    if (pageType === PageType.ORDER_STATUS_PAGE) {
        switch (slotNumber) {
            case 1:
                return React.createElement(ImageOfOspCs1, { alt: "Order Status Page Custom Slot 1" });
            case 2:
                return React.createElement(ImageOfOspCs2, { alt: "Order Status Page Custom Slot 2" });
            case 3:
                return React.createElement(ImageOfOspCs3, { alt: "Order Status Page Custom Slot 3" });
            case 4:
                return React.createElement(ImageOfOspCs4, { alt: "Order Status Page Custom Slot 4" });
            case 5:
                return React.createElement(ImageOfOspCs5, { alt: "Order Status Page Custom Slot 5" });
            case 6:
                return React.createElement(ImageOfOspCs6, { alt: "Order Status Page Custom Slot 6" });
            default:
                return React.createElement(ImageOfOspCs1, { alt: "Order Status Page Custom" });
        }
    }
    return null;
};
var getWidgetImage = function (widgetType, pageType, slotNumber) {
    // Cart Page
    if (pageType === PageType.PRE_PURCHASE_CART_PAGE) {
        switch (widgetType) {
            case PreMadeTemplateType.PRODUCT_UPSELL:
            case "MULTI_PRODUCT_UPSELL":
                return React.createElement(ImageOfCartUpsell, { alt: "Cart Upsell" });
            case PreMadeTemplateType.BUNDLE:
                return React.createElement(ImageOfCartBundle, { alt: "Cart Bundle" });
            case PreMadeTemplateType.PRODUCT_RECOMMENDATION:
            case "RECOMMENDATIONS":
                return React.createElement(ImageOfCartRecommendation, { alt: "Cart Recommendations" });
            case PreMadeTemplateType.BANNER:
                return React.createElement(ImageOfCartBanner, { alt: "Cart Banner" });
            case PreMadeTemplateType.CUSTOM_SLOT:
                return (getCustomSlotImage(pageType, slotNumber) || (React.createElement(ImageOfCartCs1, { alt: "Cart Custom" })));
            default:
                return null;
        }
    }
    // Product Page
    if (pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE) {
        switch (widgetType) {
            case PreMadeTemplateType.PRODUCT_UPSELL:
            case "MULTI_PRODUCT_UPSELL":
                return React.createElement(ImageOfProductUpsell, { alt: "Product Upsell" });
            case PreMadeTemplateType.BUNDLE:
                return React.createElement(ImageOfProductBundle, { alt: "Product Bundle" });
            case PreMadeTemplateType.PRODUCT_RECOMMENDATION:
            case "RECOMMENDATIONS":
                return React.createElement(ImageOfProductRecommendation, { alt: "Product Recommendations" });
            case PreMadeTemplateType.BANNER:
                return React.createElement(ImageOfProductBanner, { alt: "Product Banner" });
            case PreMadeTemplateType.CUSTOM_SLOT:
                return (getCustomSlotImage(pageType, slotNumber) || (React.createElement(ImageOfProductCs1, { alt: "Product Custom" })));
            default:
                return null;
        }
    }
    // Cart Drawer Page
    if (pageType === PageType.PRE_PURCHASE_CART_DRAWER_PAGE) {
        return React.createElement(ImageOfCartDrawer, { alt: "Cart Drawer" });
    }
    // Checkout Page
    if (pageType === PageType.CHECKOUT) {
        switch (widgetType) {
            case PreMadeTemplateType.PRODUCT_UPSELL:
            case "MULTI_PRODUCT_UPSELL":
                return React.createElement(ImageOfCheckoutUpsell, { alt: "Checkout Upsell" });
            case PreMadeTemplateType.BUNDLE:
                return React.createElement(ImageOfCheckoutBundle, { alt: "Checkout Bundle" });
            case PreMadeTemplateType.PRODUCT_RECOMMENDATION:
            case "RECOMMENDATIONS":
                return React.createElement(ImageOfCheckoutRecommendation, { alt: "Checkout Recommendations" });
            case PreMadeTemplateType.BANNER:
                return React.createElement(ImageOfCheckoutBanner, { alt: "Checkout Banner" });
            case PreMadeTemplateType.CUSTOM_SLOT:
                return (getCustomSlotImage(pageType, slotNumber) || (React.createElement(ImageOfCheckoutCs1, { alt: "Checkout Custom" })));
            default:
                return null;
        }
    }
    // Post Purchase Page
    if (pageType === PageType.POST_PURCHASE_PAGE1) {
        return React.createElement(ImageOfPostPurchase, { alt: "Post Purchase" });
    }
    // Thank You Page
    if (pageType === PageType.THANK_YOU_PAGE) {
        switch (widgetType) {
            case PreMadeTemplateType.PRODUCT_UPSELL:
            case "MULTI_PRODUCT_UPSELL":
                return React.createElement(ImageOfTypUpsell, { alt: "Thank You Page Upsell" });
            case PreMadeTemplateType.BUNDLE:
                return React.createElement(ImageOfTypBundle, { alt: "Thank You Page Bundle" });
            case PreMadeTemplateType.PRODUCT_RECOMMENDATION:
            case "RECOMMENDATIONS":
                return (React.createElement(ImageOfTypRecommendation, { alt: "Thank You Page Recommendations" }));
            case PreMadeTemplateType.BANNER:
                return React.createElement(ImageOfTypBanner, { alt: "Thank You Page Banner" });
            case PreMadeTemplateType.ANNOUNCEMENT_BAR:
                return React.createElement(ImageOfTypAnnouncement, { alt: "Thank You Page Announcement" });
            case PreMadeTemplateType.CUSTOM_SLOT:
                return (getCustomSlotImage(pageType, slotNumber) || (React.createElement(ImageOfTypCs1, { alt: "Thank You Page Custom" })));
            default:
                return null;
        }
    }
    // Order Status Page
    if (pageType === PageType.ORDER_STATUS_PAGE) {
        switch (widgetType) {
            case PreMadeTemplateType.PRODUCT_UPSELL:
            case "MULTI_PRODUCT_UPSELL":
                return React.createElement(ImageOfOspUpsell, { alt: "Order Status Page Upsell" });
            case PreMadeTemplateType.BUNDLE:
                return React.createElement(ImageOfOspBundle, { alt: "Order Status Page Bundle" });
            case PreMadeTemplateType.PRODUCT_RECOMMENDATION:
            case "RECOMMENDATIONS":
                return (React.createElement(ImageOfOspRecommendation, { alt: "Order Status Page Recommendations" }));
            case PreMadeTemplateType.BANNER:
                return React.createElement(ImageOfOspBanner, { alt: "Order Status Page Banner" });
            case PreMadeTemplateType.ANNOUNCEMENT_BAR:
                return React.createElement(ImageOfOspAnnouncement, { alt: "Order Status Page Announcement" });
            case PreMadeTemplateType.CUSTOM_SLOT:
                return (getCustomSlotImage(pageType, slotNumber) || (React.createElement(ImageOfOspCs1, { alt: "Order Status Page Custom" })));
            default:
                return null;
        }
    }
    return null;
};
var getPageInfo = function (isMobileView, widgetType, slotNumber) {
    var _a;
    var getCustomSlotSteps = function (widgetType) {
        if (widgetType === PreMadeTemplateType.CUSTOM_SLOT) {
            return [
                " ".concat(t("Click on"), " \"").concat(t("Custom slots"), "\" ").concat(t("in the left sidebar")),
                " ".concat(t("Select"), " \"").concat(t("Custom slot"), " ").concat(slotNumber !== null && slotNumber !== void 0 ? slotNumber : '', "\" \n            ").concat(t("from the right sidebar")),
                "".concat(t("Click"), " \"").concat(t("Save"), "\""),
                "",
            ];
        }
        return [
            " ".concat(t("Widget already added")),
            " ".concat(t("Click"), " \"").concat(t("Save"), "\""),
            "",
        ];
    };
    return _a = {},
        _a[PageType.THANK_YOU_PAGE] = {
            title: t("Thank you page"),
            buttonText: t("Go to your Thank you page"),
            steps: [
                " ".concat(t("Click"), " \"+\" ").concat(t("and select"), " \"").concat(t("Thank you page"), "\""),
                " ".concat(t("Click the"), " <span style=\"font-weight: 500;\">\"").concat(t("Save"), "\"</span> ").concat(t("button")),
                "",
            ],
            image: getWidgetImage(widgetType, PageType.THANK_YOU_PAGE, slotNumber) || React.createElement(ImageOfTypCs1, { alt: "Thank you page", borderRadius: "4px" }),
        },
        _a[PageType.ORDER_STATUS_PAGE] = {
            title: t("Order status page"),
            buttonText: t("Go to your Order status page"),
            steps: [
                " ".concat(t("Click"), " \"+\" ").concat(t("and select"), " \"").concat(t("Order status page"), "\""),
                " ".concat(t("Click the"), " <span style=\"font-weight: 500;\">\"").concat(t("Save"), "\"</span> ").concat(t("button")),
                "",
            ],
            image: getWidgetImage(widgetType, PageType.ORDER_STATUS_PAGE, slotNumber) || React.createElement(ImageOfOspCs1, { alt: "Order status page", borderRadius: "4px" }),
        },
        _a[PageType.CHECKOUT] = {
            title: t("Checkout page"),
            buttonText: t("Go to your Checkout page"),
            steps: [
                " ".concat(t("Click"), " \"+\" ").concat(t("and select"), " \"").concat(t("Checkout page"), "\""),
                " ".concat(t("Click the"), " <span style=\"font-weight: 500;\">\"").concat(t("Save"), "\"</span> ").concat(t("button")),
                "",
            ],
            image: getWidgetImage(widgetType, PageType.CHECKOUT, slotNumber) || (React.createElement(ImageOfCheckoutCs1, { alt: "Checkout page", borderRadius: "4px" })),
        },
        _a[PageType.POST_PURCHASE_PAGE1] = {
            title: t("Post purchase page"),
            buttonText: t("Go to your Post purchase page"),
            steps: [
                " ".concat(t("Scroll to the bottom and select"), " <span style=\"font-weight: 500;\">Upsell.com</span> ").concat(t("under"), " <span style=\"font-weight: 500;\">\"").concat(t("Post purchase page"), "\"</span>"),
                " ".concat(t("Click the"), " <span style=\"font-weight: 500;\">\"").concat(t("Save"), "\"</span> ").concat(t("button")),
                "",
            ],
            image: getWidgetImage(widgetType, PageType.POST_PURCHASE_PAGE1, slotNumber) || React.createElement(ImageOfTypCs1, { alt: "Post purchase page", borderRadius: "4px" }),
        },
        _a[PageType.PRE_PURCHASE_CART_PAGE] = {
            title: t("Cart page"),
            buttonText: t("Go to your Cart page"),
            steps: getCustomSlotSteps(widgetType),
            image: getWidgetImage(widgetType, PageType.PRE_PURCHASE_CART_PAGE, slotNumber) || React.createElement(ImageOfCartCs1, { alt: "Cart page", borderRadius: "4px" }),
        },
        _a[PageType.PRE_PURCHASE_PRODUCT_PAGE] = {
            title: t("Product page"),
            buttonText: t("Go to your Product page"),
            steps: getCustomSlotSteps(widgetType),
            image: getWidgetImage(widgetType, PageType.PRE_PURCHASE_PRODUCT_PAGE, slotNumber) || React.createElement(ImageOfProductCs1, { alt: "Product page", borderRadius: "4px" }),
        },
        _a[PageType.PRE_PURCHASE_CART_DRAWER_PAGE] = {
            title: t("Cart drawer page"),
            buttonText: t("Go to your Cart drawer page"),
            steps: [
                " ".concat(t("Make sure"), " <span style=\"font-weight: 500;\">Upsell.com</span> ").concat(t("toggle is on")),
                " ".concat(t("Click the"), " <span style=\"font-weight: 500;\">\"").concat(t("Save"), "\"</span> ").concat(t("button")),
                "",
            ],
            image: getWidgetImage(widgetType, PageType.PRE_PURCHASE_CART_DRAWER_PAGE, slotNumber) || React.createElement(ImageOfCartDrawer, { alt: "Cart drawer page", borderRadius: "4px" }),
        },
        _a;
};
var StepperIcon = function (_a) {
    var index$1 = _a.index, isMobileView = _a.isMobileView, pageType = _a.pageType, widgetType = _a.widgetType;
    var stepperValue = (widgetType != PreMadeTemplateType.CUSTOM_SLOT) &&
        (pageType === PageType.PRE_PURCHASE_CART_PAGE || pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE)
        ? index$1 : index$1 + 1;
    var isCheckedIcon = widgetType != PreMadeTemplateType.CUSTOM_SLOT &&
        (pageType === PageType.PRE_PURCHASE_CART_PAGE ||
            pageType === PageType.PRE_PURCHASE_PRODUCT_PAGE) &&
        index$1 === 0;
    return (React.createElement(React.Fragment, null, isCheckedIcon ? (React.createElement(CheckedIconWithBorder, { w: isMobileView ? "30px" : "25px", h: isMobileView ? "30px" : "25px", className: "qsm-checked-icon-with-border" })) : (React.createElement(Box, { borderRadius: isMobileView ? "50%" : "15px", border: "1px solid", borderColor: "#1B1BB1", background: "#EEF1F9", w: isMobileView ? "30px" : "25px", h: isMobileView ? "30px" : "25px", minW: isMobileView ? "30px" : "25px", minH: isMobileView ? "30px" : "25px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: isMobileView ? "14px" : "12px", fontWeight: "600", color: "primary.800", className: "qsm-stepper-value" }, stepperValue))));
};
var PageSetup = function (_a) {
    var pageType = _a.pageType, onGoToPage = _a.onGoToPage, checkStatusButton = _a.checkStatusButton, _b = _a.isMobileView, isMobileView = _b === void 0 ? false : _b, widgetType = _a.widgetType, slotNumber = _a.slotNumber, editorRedirectionConfig = _a.editorRedirectionConfig, slotStatus = _a.slotStatus, onContactSupport = _a.onContactSupport, _c = _a.direction, direction = _c === void 0 ? "ltr" : _c;
    var pageInfo = getPageInfo(isMobileView, widgetType, slotNumber)[pageType];
    var pageTitle = (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.title) || "";
    var slotStatusErrorMessage = useMemo(function () {
        // Don't show error message if check status button is success or disabled
        if ((checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isSuccess) || (checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isDisabled)) {
            return null;
        }
        if (!slotStatus) {
            return null;
        }
        if (slotStatus === "detected") {
            return (React.createElement(Flex, null,
                React.createElement(Flex, { gap: 2, alignItems: "center", justifyContent: "center", className: "qsm-error-msg-content" },
                    React.createElement(InfoFilled, { height: "12px", width: "12px", color: "error.700", className: "qsm-error-msg-icon" }),
                    React.createElement(Typography, { variant: "body", color: "error.800", letterSpacing: "-0.5px", className: "qsm-error-msg-text" },
                        t("You placed the widget on the "),
                        t(pageTitle),
                        t(", but you didn't save it in Shopify editor. Please go back to "),
                        t(pageTitle),
                        t(" and save the changes.")))));
        }
        if (slotStatus === "pending") {
            return (React.createElement(Flex, null,
                React.createElement(Flex, { gap: 2, alignItems: "center", justifyContent: "center", className: "qsm-error-msg-content" },
                    React.createElement(InfoFilled, { height: "12px", width: "12px", color: "error.700", className: "qsm-error-msg-icon" }),
                    React.createElement(Typography, { variant: "body", color: "error.800", letterSpacing: "-0.5px", className: "qsm-error-msg-text" },
                        t("The Upsell.com widget is not placed on "),
                        t(pageTitle),
                        t(". Please follow the steps above or "),
                        React.createElement("span", { style: { textDecoration: "underline", cursor: "pointer" }, onClick: onContactSupport, className: "qsm-error-msg-link" }, t("contact support."))))));
        }
        return null;
    }, [
        slotStatus,
        pageTitle,
        onContactSupport,
        checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isSuccess,
        checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isDisabled,
    ]);
    var handleGoToEditor = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var shopifyApiKey, platformStoreId, checkoutProfileId, shopifyAppId, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!editorRedirectionConfig) return [3 /*break*/, 3];
                    if (!(onGoToPage === null || onGoToPage === void 0 ? void 0 : onGoToPage.onBeforeNavigate)) return [3 /*break*/, 2];
                    return [4 /*yield*/, onGoToPage.onBeforeNavigate()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    shopifyApiKey = editorRedirectionConfig.shopifyApiKey, platformStoreId = editorRedirectionConfig.platformStoreId, checkoutProfileId = editorRedirectionConfig.checkoutProfileId, shopifyAppId = editorRedirectionConfig.shopifyAppId;
                    url = getEditorRedirectionUrl(pageType, shopifyApiKey, platformStoreId, checkoutProfileId, shopifyAppId, widgetType);
                    if (url) {
                        console.log("Redirecting to editor: ", url);
                        window.open(url, "_blank");
                    }
                    return [2 /*return*/];
                case 3:
                    if (onGoToPage === null || onGoToPage === void 0 ? void 0 : onGoToPage.onClick) {
                        onGoToPage.onClick();
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [onGoToPage, editorRedirectionConfig, pageType, widgetType]);
    if (!pageInfo) {
        return null;
    }
    var buttonText = pageInfo.buttonText, steps = pageInfo.steps, image = pageInfo.image;
    var imageWidth = isMobileView ? "238px" : "415px";
    var imageHeight = isMobileView ? "154px" : "250px";
    var flexDirection = isMobileView ? "column" : "row";
    var leftContent = (React.createElement(Flex, { direction: "column", gap: "24px", justifyContent: "center", alignItems: isMobileView ? "center" : "flex-start", className: "qsm-left-content" },
        React.createElement(Box, { border: "1px solid #E4E8EE", borderRadius: "8px", p: "12px", width: isMobileView ? "100%" : "410px", maxWidth: isMobileView ? "320px" : "410px", className: "qsm-left-content-box" },
            React.createElement(Flex, { direction: "column", gap: "12px", className: "qsm-instructions-content" },
                React.createElement(Button, { minHeight: isMobileView ? "44px" : "36px", height: "auto", p: "8px 16px", colorScheme: "primary", rightIcon: React.createElement(ExternalLink, { className: "qsm-external-link-icon" }), onClick: handleGoToEditor, justifyContent: "flex-start", width: "fit-content", maxWidth: "100%", isLoading: onGoToPage === null || onGoToPage === void 0 ? void 0 : onGoToPage.isLoading, isDisabled: onGoToPage === null || onGoToPage === void 0 ? void 0 : onGoToPage.isDisabled, className: "qsm-redirect-btn" },
                    React.createElement(Typography, { variant: "body", sx: {
                            fontSize: "16px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            textAlign: "start",
                        }, fontWeight: 500, className: "qsm-redirect-btn-text" }, buttonText)),
                React.createElement(Flex, { flexDirection: "column", className: "qsm-instructions-list" }, steps.map(function (step, index$1) {
                    var isCheckStatusStep = step === "";
                    return (React.createElement(Box, { key: index$1, className: "qsm-instruction-item" },
                        React.createElement(Flex, { alignItems: "center", gap: 2, position: "relative", height: "36px", className: "qsm-instruction-item-content" },
                            React.createElement(StepperIcon, { index: index$1, isMobileView: isMobileView, pageType: pageType, widgetType: widgetType }),
                            isCheckStatusStep ? (React.createElement(Flex, { direction: "column", gap: "4px", className: "qsm-check-status-content" }, (checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isSuccess) ? (React.createElement(Flex, { p: "8px 16px", borderRadius: "8px", background: "success.100", border: "1px solid", borderColor: "success.500", alignItems: "center", gap: 2, height: isMobileView ? "44px" : "36px", className: "qsm-check-status-success-btn" },
                                React.createElement(CheckCircle, { height: "16px", width: "16px", color: "success.800", className: "qsm-check-status-success-icon" }),
                                React.createElement(Typography, { variant: "small-i", color: "neutrals.900", className: "qsm-check-status-success-btn-text" }, t("Success. Please continue.")))) : (React.createElement(Button, { variant: "secondary", size: "sm", onClick: checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.onClick, height: isMobileView ? "44px" : "36px", isLoading: checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isLoading, isDisabled: checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isDisabled, className: "qsm-check-status-btn".concat((checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isLoading)
                                    ? " qsm-check-status-btn-loading"
                                    : "").concat((checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.isDisabled)
                                    ? " qsm-check-status-btn-disabled"
                                    : "") }, (checkStatusButton === null || checkStatusButton === void 0 ? void 0 : checkStatusButton.label) || t("Check status"))))) : (React.createElement(Typography, { variant: "small-i", color: "neutrals.900", className: "qsm-instruction-item-text", dangerouslySetInnerHTML: { __html: step } }))),
                        step !== "" && (React.createElement(Box, { margin: isMobileView ? "0 14px" : "0 12px", w: isMobileView ? "2px" : "1.5px", h: "12px", borderRadius: "2px", background: "#EEF1F9", border: "1px solid #1B1BB1", className: "qsm-instruction-item-line" }))));
                }))),
            slotStatusErrorMessage && (React.createElement(Box, { mt: "4px", className: "qsm-error-msg" }, slotStatusErrorMessage)))));
    var imageSection = (React.createElement(Box, { borderRadius: "24px", border: "20px solid #F0DE8E", background: "#F0D9B0", height: "fit-content", flexShrink: 0, alignSelf: isMobileView ? "center" : "auto", className: "qsm-image-section" }, getImageWithSize(image, imageWidth, imageHeight)));
    return (React.createElement(Flex, { gap: isMobileView ? "32px" : "59px", flexDirection: flexDirection, alignItems: "center", justifyContent: "center", w: isMobileView ? "100%" : "max-content", className: "qsm-container", dir: direction }, isMobileView ? (React.createElement(React.Fragment, null,
        imageSection,
        leftContent)) : (React.createElement(React.Fragment, null,
        leftContent,
        imageSection))));
};
var getImageWithSize = function (image, imageWidth, imageHeight) {
    return React.cloneElement(image, {
        width: imageWidth,
        height: imageHeight,
    });
};

export { PageSetup as default };
//# sourceMappingURL=PageSetup.js.map
